import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class FinancialReportService {
  /**
   * Récupère le récapitulatif financier
   * @param {Object} params - Paramètres
   */
  async getSummary(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/financial/summary${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère la liste des transactions
   * @param {Object} params - Paramètres
   */
  async getTransactions(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/financial/transactions${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message: error.response?.data?.error || "Erreur financière",
      status: error.response?.status,
    };
  }
}

export default new FinancialReportService();
